module.exports = __webpack_public_path__ + "img/icone-onde-encontrar.507a6914.png";